import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InfotecsData } from 'Pages/registratorCabinet'

type infotecsState = {
	infotecsData: InfotecsData
}

export const infotecsInitialState: infotecsState = {
	infotecsData: null,
}

export namespace InfotecsNS {
	export type getInfotecsData = PayloadAction<{ id: string; reloadRbidosRequest?: boolean }>
	export type setInfotecsData = PayloadAction<InfotecsData>
	export type clearInfotecsData = PayloadAction
	export type reloadInfotecsData = PayloadAction<{ id: number; rbidos_id?: number }>
	export type repeatIdentification = PayloadAction<{
		id: number
		data: { message: string }
		request_id: number
	}>
	export type infotecsReloadDataSocket = PayloadAction<{ id: number }>
	export type sendToInfotecs = PayloadAction<{
		id: number
		rbidos_id: number
		requestInterval: boolean
	}>
	export type cancelIdentification = PayloadAction<{ id: number; rbidos_id: number }>
	export type setPassportData = PayloadAction<{ data: InfotecsData }>
	export type infotecsSearch = PayloadAction<{ id: number }>
	export type rbidosBind = PayloadAction<{ id: number; rbidos_id: number }>
}

export const infotecsSlice = createSlice({
	name: 'infotecs',
	initialState: infotecsInitialState,
	reducers: {
		getOne: (state, action: InfotecsNS.getInfotecsData) => {},
		setOne: (state, action: InfotecsNS.setInfotecsData) => {
			state.infotecsData = action.payload
		},
		clearOne: (state, action: InfotecsNS.clearInfotecsData) => {
			state.infotecsData = null
		},
		reloadInfotecsData: (state, action: InfotecsNS.reloadInfotecsData) => {},
		repeatIdentification: (state, action: InfotecsNS.repeatIdentification) => {},
		infotecsReloadDataSocket: (state, action: InfotecsNS.infotecsReloadDataSocket) => {},
		sendToInfotecs: (state, action: InfotecsNS.sendToInfotecs) => {},
		cancelIdentification: (state, action: InfotecsNS.cancelIdentification) => {},
		setPassportData: (state, action: InfotecsNS.setPassportData) => {
			state.infotecsData = { ...state.infotecsData, ...action.payload.data }
		},
		infotecsSearch: (state, action: InfotecsNS.infotecsSearch) => {},
		rbidosBind: (state, action: InfotecsNS.rbidosBind) => {},
	},
})
